import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "tagName"];
import { Fragment } from 'react';
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Title = props => {
  var {
      keyname = 'title',
      name,
      tagName = 'h1'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!elmProps.children) {
    elmProps.children = /*#__PURE__*/_jsxs(Fragment, {
      children: ["We are ", /*#__PURE__*/_jsx("b", {
        children: "Login"
      })]
    });
  }
  return /*#__PURE__*/_jsx(Block, _extends({
    tagName: tagName
  }, elmProps, {
    keyname: name || keyname
  }));
};
Title.displayName = 'Login.Title';